import Api from "./Api";
import Csrf from "./Csrf";

export default {
	
	async validityActiveUpdate(validity_id,form){
		await Csrf.getCookie();

		return Api.put('/validity/'+validity_id+'/update',form);
	}
	
};